export default "__VITE_ASSET__af42d406__"